<template>
  <div>
    <div>
      <div class="second-bar" v-if="!isLeadView">
        <div class="quick-filter-action" v-for="option in quickFilterOptions" :key="option.key"
             :style="`background-color: ${option.color}; color: ${option.textColor};`">
          {{ option.label }}
        </div>
      </div>
      <div class="second-bar-admin" v-else>
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <CountStatusUIv2
              :filterForm="filterForm"
              :totalContactModule="totalContactModule"
              :typeHeaderContactModule="typeHeaderStatusModule"
              :contactModuleList="countStatusModuleList"
            />
          </v-col>
          <v-col cols="12" class="pt-0 pb-0" v-if="this.$route.query.tutorSchoolLevel === 'primary'">
            <QuickFilter
              :filterForm="filterForm"
              :typeHeaderContactModule="typeHeaderStatusModule"
              :contactModuleList="countStatusModuleList">
            </QuickFilter>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="periodically-care-table">
      <PeriodicallyTable
        v-if="true"
        :studentForm="studentForm"
        :filterForm="filterForm"
        @show-modal-quick-view="showQuickView"
      />
    </div>
    <modal-quick-view
      v-if="isOpenQuickView"
      :isShow="isOpenQuickView"
      :contact="selectedContact"
      :contactId="selectedContactId"
      :id="selectedItemId"
      :filter-form.sync="filterForm"
      :dataContact="dataContact"
      :contactStatusList="contactStatusList"
      :users="usersContactAdvise"
      :routine-student-id="selectedRoutineStudentId"
      :homeroomTeacherName="homeroomTeacherName"
      :homeroomTeacher="homeroomTeacher"
      :levels="levels"
      :taskType="1"
      @closeModalQuickView="closeModalQuickView()"
    />
  </div>
</template>
<script>
import { TUTOR_TAB_INDEX } from '@/modules/student_care/constant/constant';
import { mapActions, mapGetters, mapState } from 'vuex';
import TokenService from '@/helpers/token';
import CountStatusUIv2 from '@/components/common/CountStatusUIv2/index.vue';
import QuickFilter from '@/modules/student_care/components/QuickFilter.vue';
import PeriodicallyTable from './periodically_care/PeriodicallyTable.vue';
import ModalQuickView from './ModalQuickView.vue';
import {
  LEVELS,
} from '../store/mutation-types';

export default {
  name: 'PeriodicallyCare',
  components: {
    CountStatusUIv2,
    PeriodicallyTable,
    ModalQuickView,
    QuickFilter,
  },
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
    studentForm: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      TUTOR_TAB_INDEX,
      isLoading: false,
      isTeacher: false,
      isOpenQuickView: false,
      selectedContactId: 0,
      selectedRoutineStudentId: 0,
      dataContact: {},
      contactStatusList: [],
      usersContactAdvise: [],
      quickFilterOptions: [
        {
          label: 'Tất cả',
          key: 'all',
          color: '#FFFFFF',
          textColor: '#E91E63',
        },
        {
          label: 'Mới',
          key: 'new',
          color: '#EB5757',
          textColor: '#FFFFFF',
        },
        {
          label: 'KNM',
          key: 'knm',
          color: '#0D47A1',
          textColor: '#FFFFFF',
        },
        {
          label: 'Gọi lại',
          key: 'call_back',
          color: '#AB47BC',
          textColor: '#FFFFFF',
        },
        {
          label: 'Hỗ trợ thêm',
          key: 'need_support',
          color: '#C62828',
          textColor: '#FFFFFF',
        },
        {
          label: 'Hoàn thành',
          key: 'completed',
          color: '#27AE60',
          textColor: '#FFFFFF',
        },
        {
          label: 'Chưa gọi',
          key: 'unresovled',
          color: '#F2C94C',
          textColor: '#FFFFFF',
        },
      ],
      subjects: {
        1: 'Toán', 2: 'Vật lý', 3: 'Hóa học', 5: 'Tiếng anh', 15: 'Ngữ Văn',
      },
      selectedCustomerId: 0,
      homeroomTeacherName: '',
      homeroomTeacher: {},
      selectedItemId: 0,
      levels: LEVELS,
      selectedContact: null,
    };
  },
  created() {
  },
  async mounted() {
    const loading = this.$loading.show();
    if (!this.courseExtensionShowField) {
      await this.getCourseExtensionShowField();
    }
    loading.hide();
  },
  computed: {
    ...mapState('student_care', ['dataPeriodicallyCareTable', 'courseExtensionShowField', 'typeHeaderStatusModule', 'countStatusModuleList', 'totalContactModule']),
    ...mapState('contact_status', ['listStatus']),
    ...mapGetters('user', ['isLeadView']),
    totalSelected() {
      return this.studentForm.selected.length;
    },
    mapCallStatus() {
      if (!this.listStatus || this.listStatus.length < 1) {
        return {};
      }
      const result = {};
      this.listStatus.forEach((callType) => {
        if (callType && callType.data && callType.data.length > 0) {
          callType.data.forEach((callStatus) => {
            result[callStatus.id] = {
              callType: callType.name,
              name: `${callType.name}-${callStatus.name}`,
              color: callStatus.color,
            };
          });
        }
      });
      return result;
    },
  },
  methods: {
    ...mapActions('student_care', [
      'getListStudentClass',
      'getCourseExtensionShowField',
      'getTeacherList',
    ]),
    showQuickView(item) {
      this.selectedContact = item;
      this.selectedContactId = item.contact_id;
      this.selectedCustomerId = item.lms_core_user_id;
      this.selectedRoutineStudentId = item.id;
      this.homeroomTeacher = { id: item.homeroom_teacher_id, name: item.homeroom_teacher_name };
      this.selectedItemId = item.id;
      setTimeout(() => {
        this.isOpenQuickView = true;
      }, 0);
    },
    closeModalQuickView() {
      this.isOpenQuickView = false;
      this.selectedContactId = 0;
    },
    clickExecuteCall(dataContact, phone) {
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phone,
          store: 'T',
        };
        Bus.$emit('voice-call-show-popup', data);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex}` : '';
      // return result ? {
      //   r: parseInt(result[1], 16),
      //   g: parseInt(result[2], 16),
      //   b: parseInt(result[3], 16),
      // } : null;
    },
  },
};
</script>

<style scoped lang="scss">
.second-bar {
  margin-top: 15px;
  min-height: 39px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
}

.second-bar-admin {
  margin-top: 28px;
  margin-bottom: 28px;
}

.quick-filter-action {
  min-height: 39px;
  border-radius: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 13px;
  margin-right: 1px;
  cursor: pointer;
}
.list-status-history {
  margin-right: 5px;
  width: 39px;
  height: 25px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  padding-top: 5px;
}
.course-extension-table {
  margin-top: 15px;
}
</style>
